import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Alert, Button } from 'react-bootstrap';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PayUFailure = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  
  const paymentStatus = params.get('status');
  const errorMessage = params.get('error_Message');
  const txnid = params.get('txnid');

  useEffect(() => {
    // Log the failed payment to your backend
    console.log('Payment failed:', { txnid, errorMessage });

    // Notify parent window with payment details
    if (window.opener) {
      window.opener.postMessage(
        { type: "payment_failure", txnid, status: paymentStatus },
        "*"
      );
    }

    // Redirect to PayUPayment with query parameters
    const queryParams = new URLSearchParams();
    if (txnid) queryParams.set("txnid", txnid);
    if (paymentStatus) queryParams.set("status", paymentStatus);
    if (errorMessage) queryParams.set("error_Message", errorMessage);

    setTimeout(() => {
      navigate(`/pay-u-payment?${queryParams.toString()}`);
    }, 1000);
  }, [navigate, txnid, paymentStatus, errorMessage]);

  return (
    <Container className="py-5 text-center">
      <div className="d-flex justify-content-center mb-4">
        <FontAwesomeIcon 
          icon={faTimesCircle} 
          size="4x" 
          className="text-danger"
        />
      </div>
      <h2 className="mb-3">Payment Failed</h2>
      <Alert variant="danger" className="mb-4">
        <p className="mb-1">Transaction ID: {txnid || "N/A"}</p>
        <p className="mb-1">Status: {paymentStatus || "Failed"}</p>
        <p>Error: {errorMessage || 'Payment could not be processed'}</p>
      </Alert>
      <p className="mb-4">
        Please try again or contact support if the problem persists.
      </p>
      <div className="d-flex justify-content-center gap-3">
        <Button 
          variant="danger" 
          onClick={() => navigate(`/`)}
        >
          Try Again
        </Button>
        <Button 
          variant="secondary" 
          onClick={() => navigate('/')}
        >
          Contact Support
        </Button>
      </div>
    </Container>
  );
};

export default PayUFailure;